// Updates the DOM Elements and navigation header visibility
//! NOTE: more than one language is required to activate the menu

export default async function renderDocumentationNavigation(jumps = [], languages = []) {
  const display = ['none', 'block'];
  const classnames = { 'has-docs-menu': null, 'has-lang-menu': null, 'has-jump-menu': null };

  const showJumps = jumps.length ? 1 : 0;
  const showLangs = languages.length > 1 ? 1 : 0;

  const navBar = document.querySelector('.c-header__docs-menus-wrap');
  if (navBar) {
    classnames['has-docs-menu'] = true;
  }

  const jumpMenu = document.querySelector('div[data-jump-menu]');
  if (jumpMenu) {
    jumpMenu.style.display = display[showJumps];
    classnames['has-jump-menu'] = showJumps;
  }

  const codeLangMenu = document.querySelector('div[data-js-codelang-menu-outer-wrap]');
  if (codeLangMenu) {
    codeLangMenu.style.display = display[showLangs];
    classnames['has-lang-menu'] = showLangs;
  }

  // adds relevant classnames to header container
  const header = document.querySelector('[data-js-header-wrap]');
  Object.entries(classnames).forEach(([selector, value]) => {
    header.classList[value ? 'add' : 'remove'](selector);
  });

  // sidebar offset
  const content = document.querySelector('.js-sticky-container');
  const sidebar = document.querySelector('.c-sidebar');
  if (sidebar) {
    const { top } = content.getBoundingClientRect();
    sidebar.dataset.offsetTop = top;
  }
}
